import { useTranslation } from 'react-i18next';
import { FormNotification } from '../../../components/form/form-notification';

interface UnsavedChangesBannerProps {
  onDismiss: () => void;
  className?: string;
}

export const UnsavedChangesBanner = ({
  onDismiss,
  className,
}: UnsavedChangesBannerProps) => {
  const { t } = useTranslation();

  return (
    <div role="alert" className={className}>
      <FormNotification
        title={t('unsavedChangesTitle')}
        type="warning"
        onDismiss={onDismiss}
      >
        {t('unsavedChangesMessage')}
      </FormNotification>
    </div>
  );
};
